/* Sofort-Vorschau fuer den Warenkorb (PROJ-72, 08.08.2026).
 *
 * Die Editoren rufen window.kaSofortVorschau(stageEl, jobId) direkt vor dem
 * Cart-Add auf: Schnappschuss der sichtbaren Vorschau (html2canvas, on
 * demand nachgeladen) -> sessionStorage 'kaCartPreview:<jobId>'. Der
 * Warenkorb (snippets/line-item.liquid) zeigt dieses Bild SOFORT, waehrend
 * der Render-Server das persistente Komposit/Downscale noch schreibt
 * (blanket_renders/<job>_cartpreview.jpg — der Weg fuer Reload, andere
 * Geraete und die Bestellansicht).
 *
 * Immer fail-soft: nach spaetestens 2,5 s ist das Promise erfuellt — die
 * Vorschau darf den Kauf nie blockieren.
 */
(function () {
  'use strict';
  window.kaSofortVorschau = window.kaSofortVorschau || function (el, jobId) {
    return new Promise(function (fertig) {
      if (!el || !jobId || !window.sessionStorage) return fertig();
      var erledigt = false;
      var done = function () { if (!erledigt) { erledigt = true; fertig(); } };
      var mach = function () {
        try {
          window.html2canvas(el, {
            useCORS: true,
            backgroundColor: '#ffffff',
            scale: Math.min(1, 360 / Math.max(1, el.clientWidth)),
            logging: false,
          }).then(function (canvas) {
            try {
              sessionStorage.setItem('kaCartPreview:' + jobId, canvas.toDataURL('image/jpeg', 0.75));
            } catch (e) { /* Storage voll o.ae. */ }
            done();
          }).catch(done);
        } catch (e) { done(); }
      };
      if (typeof window.html2canvas === 'function') {
        mach();
      } else {
        var s = document.createElement('script');
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
        s.onload = mach;
        s.onerror = done;
        document.head.appendChild(s);
      }
      setTimeout(done, 2500); // Notbremse
    });
  };

  // html2canvas beim Seiten-Idle vorwaermen: der Erst-Load + erster Lauf
  // dauern zusammen laenger als die Notbremse — vorgeladen ist der
  // Schnappschuss beim Cart-Add in ~300-800 ms fertig.
  var vorladen = function () {
    if (typeof window.html2canvas === 'function') return;
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
    s.defer = true;
    document.head.appendChild(s);
  };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(vorladen, { timeout: 5000 });
  } else {
    setTimeout(vorladen, 3000);
  }
})();
